var map = {
	"./af.yml": "1831",
	"./bd.yml": "7e03",
	"./bf.yml": "46c7",
	"./cs.yml": "aa95",
	"./ct.yml": "e2d6",
	"./de.yml": "363b",
	"./el.yml": "a6fa",
	"./en.yml": "eb57",
	"./es.yml": "4020",
	"./et.yml": "773f",
	"./gs.yml": "1d26",
	"./hr.yml": "e603",
	"./hu.yml": "2020",
	"./iw.yml": "4abb",
	"./ja.yml": "d602",
	"./ka.yml": "b867",
	"./ko.yml": "096c",
	"./ms.yml": "0abe",
	"./nl.yml": "31f5",
	"./no.yml": "3de3",
	"./pl.yml": "958c",
	"./pt.yml": "67c3",
	"./ru.yml": "01aa",
	"./sf.yml": "67c7",
	"./sl.yml": "8878",
	"./sp.yml": "c42c",
	"./sv.yml": "9d6a",
	"./ta.yml": "8535",
	"./th.yml": "e0ee",
	"./xh.yml": "c64d",
	"./zh.yml": "1cbb",
	"./zu.yml": "afa7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6c36";